module.exports = __webpack_public_path__ + "static/media/zoho.6b204c7a.svg";